import { Button } from '@ixyberfree/ixybercomponents';

import * as hmiclientbase from 'components/hmilib/hmiclientbase';
import { IComboBoxData } from 'components/modules/trends/GroupTrend/ComboBox/ComboBox';
import React, { useEffect, useState } from 'react';
import { SelectedElem } from '../../Settings';
import Search from '../Search/Search';

interface IPropsAddressList {
    refType: string;
    data: any;
    closeCB?: Function;
    saveCB?: (address: string) => void;
}

function AddressList(props: IPropsAddressList) {
    const { refType, data, closeCB, saveCB } = props;

    const [comboBoxData, setComboBoxData] = useState<IComboBoxData[]>([]);
    const [selectedAddress, setSelectedAddress] = useState<SelectedElem>({ id: '', value: '' });

    useEffect(() => {
        getRefObj(refType);
    }, [data]);

    const getPath = () => {
        hmiclientbase
            .SettingsGetPathsType('iXyberBaseLib.Parameter')
            .then((items) => {
                const newItems = items.filter((item: string) => {
                    return !item.includes('TEMPLATES');
                });

                return newItems;
            })
            .then((items) => {
                const comboBoxData = items.map((item: string, index: number) => {
                    if (item == data.address) {
                        setSelectedAddress({ id: `${index}`, value: item });
                    }

                    return { id: index, value: item };
                });

                setComboBoxData(comboBoxData);
            });
    };

    const getRefObj = (type: string) => {
        hmiclientbase.SettingsGetIdsObjects({ type: type }).then((arrId: any) => {
            arrId.map((id: string) => {
                hmiclientbase.SettingsGetObjectDto(id).then((res: any) => {
                    if (data.refinterface.rpathcv == res.path) {
                        if (res.ClassName == 'iXyberBaseLib.DataInterface.Clients.ClientSYSTEM') {
                            getPath();
                        }
                    }
                });
            });
        });
    };

    return (
        <div style={{ width: '250px', padding: '5px' }}>
            <Search
                data={comboBoxData}
                selected={selectedAddress.id}
                onClick={(item: any) => {
                    setSelectedAddress(item);
                }}
                onEnter={(item) => {
                    setSelectedAddress(item);
                }}
                placeholder="Поиск"
                width="100%"
            />
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '1em' }}>
                <Button
                    text="Сохранить"
                    size="small"
                    styleType="filled"
                    onClick={() => saveCB && saveCB(selectedAddress.value)}
                />
                <div style={{ width: '1.8em' }}></div>
                <Button text="Отмена" size="small" styleType="tinted" onClick={() => closeCB && closeCB()} />
            </div>
        </div>
    );
}

export default AddressList;
